<template>
    <div class="navbar-wrapper">
        <!-- Desktop Navigation -->
        <el-menu
            v-if="!isMobile"
            :default-active="activeMenu"
            :class="
                zoom
                    ? 'el-menu-horizontal-demo zoomed'
                    : 'el-menu-horizontal-demo'
            "
            mode="horizontal"
            menu-trigger="hover"
        >
            <template v-if="isProfileMode">
                <!-- Profile navigation items -->
                <el-menu-item
                    index="/profile/school"
                    @click="navigateRouter('/profile/school')"
                >
                    Trường học
                </el-menu-item>
                <el-menu-item
                    index="/profile/teacher"
                    @click="navigateRouter('/profile/teacher')"
                >
                    Giáo viên
                </el-menu-item>
                <el-menu-item
                    index="/profile/student"
                    @click="navigateRouter('/profile/student')"
                >
                    Học sinh
                </el-menu-item>
            </template>
            <template v-else>
                <template v-for="item in auth_user?.permission.slice(0, 7) || []">
                    <el-submenu
                        mode="horizontal"
                        v-if="item.hasChildren"
                        :key="item.path"
                        :index="item.path"
                        v-on:click="navigateRouter(item.path)"
                    >
                        <template slot="title">
                            <span @click="navigateRouter(item.path)">
                                {{ item.name }}
                            </span>
                        </template>

                        <template v-for="(child, index) in item.children">
                            <el-submenu
                                v-if="child.hasChildren"
                                :key="index"
                                :index="child.path"
                            >
                                <template slot="title">
                                    {{ child.name }}</template
                                >
                                <el-menu-item
                                    v-for="grandchild in child.children"
                                    :key="grandchild.path"
                                    :index="grandchild.path"
                                    v-on:click="navigateRouter(grandchild.path)"
                                >
                                    {{ grandchild.name }}
                                </el-menu-item>
                            </el-submenu>
                            <el-menu-item
                                v-else
                                :key="child.path"
                                :index="child.path"
                                v-on:click="navigateRouter(child.path)"
                            >
                                {{ child.name }}
                            </el-menu-item>
                        </template>
                    </el-submenu>
                    <el-menu-item v-else :key="item.path" :index="item.path">
                        <i v-if="item.icon" :class="item.icon"></i>
                        <span @click="navigateRouter(item.path)">
                            {{ item.name }}
                        </span>
                    </el-menu-item>
                </template>
            </template>
        </el-menu>

        <!-- Mobile Navigation -->
        <div v-else class="mobile-nav-container">
            <b-button
                v-b-toggle.mobile-nav
                variant="primary"
                class="mobile-menu-toggle"
            >
                <i class="el-icon-menu"></i> Menu
            </b-button>

            <b-collapse id="mobile-nav" class="mt-2">
                <b-card>
                    <el-menu
                        :default-active="activeMenu"
                        class="el-menu-vertical-demo"
                        mode="vertical"
                    >
                        <template v-if="isProfileMode">
                            <!-- Profile navigation items for mobile -->
                            <el-menu-item
                                index="/profile/school"
                                @click="navigateRouter('/profile/school')"
                            >
                                Trường học
                            </el-menu-item>
                            <el-menu-item
                                index="/profile/teacher"
                                @click="navigateRouter('/profile/teacher')"
                            >
                                Giáo viên
                            </el-menu-item>
                            <el-menu-item
                                index="/profile/student"
                                @click="navigateRouter('/profile/student')"
                            >
                                Học sinh
                            </el-menu-item>
                        </template>
                        <template v-else>
                            <template
                                v-for="item in auth_user?.permission.slice(
                                    0,
                                    7
                                ) || []"
                            >
                                <el-submenu
                                    v-if="item.hasChildren"
                                    :key="item.path"
                                    :index="item.path"
                                >
                                    <template slot="title">
                                        <span @click="navigateRouter(item.path)">
                                            {{ item.name }}
                                        </span>
                                    </template>

                                    <template
                                        v-for="(child, index) in item.children"
                                    >
                                        <el-submenu
                                            v-if="child.hasChildren"
                                            :key="index"
                                            :index="child.path"
                                        >
                                            <template slot="title">
                                                {{ child.name }}</template
                                            >
                                            <el-menu-item
                                                v-for="grandchild in child.children"
                                                :key="grandchild.path"
                                                :index="grandchild.path"
                                                v-on:click="
                                                    navigateRouter(
                                                        grandchild.path
                                                    )
                                                "
                                            >
                                                {{ grandchild.name }}
                                            </el-menu-item>
                                        </el-submenu>
                                        <el-menu-item
                                            v-else
                                            :key="child.path"
                                            :index="child.path"
                                            v-on:click="
                                                navigateRouter(child.path)
                                            "
                                        >
                                            {{ child.name }}
                                        </el-menu-item>
                                    </template>
                                </el-submenu>
                                <el-menu-item
                                    v-else
                                    :key="item.path"
                                    :index="item.path"
                                >
                                    <i v-if="item.icon" :class="item.icon"></i>
                                    <span @click="navigateRouter(item.path)">
                                        {{ item.name }}
                                    </span>
                                </el-menu-item>
                            </template>
                        </template>
                    </el-menu>
                </b-card>
            </b-collapse>
        </div>
    </div>
</template>

<script>
import { getFromSessionStorage } from '@/utils/session'
export default {
    name: 'AV',
    data() {
        return {
            activeMenu: null,
            isMobile: false
        }
    },
    methods: {
        navigateRouter(path) {
            // Don't navigate if path is invalid or is a parent menu placeholder
            if (
                !path ||
                path === '/sap-nhap-giai-the' ||
                path === '/Specific-data'
            ) {
                return
            }

            const route = this.$router.resolve({ path })

            if (route.resolved.matched.length > 0) {
                if (this.$route.path === path) {
                    window.location.reload()
                } else {
                    this.$router.push(path).catch((err) => {
                        if (err.name !== 'NavigationDuplicated') {
                            console.error(err)
                        }
                    })
                }
            } else {
                console.log(`Đường dẫn ${path} không tồn tại`)
            }
        },
        handleRouteChange(to) {
            const path = to.path

            this.activeMenu = path

            const fullPath = `${to.path}?${Object.entries(to.query)
                .map(([key, value]) => `${key}=${value}`)
                .join('&')}`
            if (fullPath && to.query.type) {
                this.activeMenu = fullPath
            }
        },

        checkScreenSize() {
            this.isMobile = window.innerWidth < 768
        },
        fixSchoolMergeDissolveMenu(user) {
            if (!user || !user.permission) return user

            // Find "Tra cứu" menu
            const lookupMenu = user.permission.find(
                (item) => item.name === 'Tra cứu'
            )

            if (!lookupMenu || !lookupMenu.children) return user

            // Find the merge/dissolve menu item
            const mergeDissolveItem = lookupMenu.children.find(
                (item) => item.name === 'Sáp nhập và giải thể trường học'
            )

            if (mergeDissolveItem) {
                // Add missing properties
                if (!mergeDissolveItem.path) {
                    mergeDissolveItem.path = '/sap-nhap-giai-the'
                }
                mergeDissolveItem.hasChildren = true

                // Fix children paths (remove leading spaces)
                if (mergeDissolveItem.children) {
                    mergeDissolveItem.children.forEach((child) => {
                        if (child.path) {
                            child.path = child.path.trim()
                        }
                        child.hasChildren = false
                    })
                }
            }

            return user
        }
    },
    watch: {
        $route(to) {
            this.handleRouteChange(to)
        }
    },
    mounted() {
        this.handleRouteChange(this.$route)
        this.checkScreenSize()
        window.addEventListener('resize', this.checkScreenSize)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkScreenSize)
    },
    computed: {
        zoom() {
            return this.$store.state.zoom.zoom
        },
        auth_user() {
            const user = getFromSessionStorage('auth_user')
            // Fix the merge/dissolve menu structure from backend
            return this.fixSchoolMergeDissolveMenu(user)
        },
        // Add computed property to check if we're in profile mode
        isProfileMode() {
            return this.$route.path.startsWith('/profile')
        }
    }
}
</script>

<style scoped>
::v-deep .el-submenu .el-submenu__title,
::v-deep .el-menu-item {
    color: #212529 !important; /* Updated navbar text color */
}
::v-deep .el-menu-item.is-active {
    border-bottom: 0px;
}
.navbar-wrapper {
    position: sticky;
    top: 64px;
    z-index: 999;
    background-color: #fff;
}

.el-menu-horizontal-demo {
    background-color: #fff;
}

.el-menu-horizontal-demo,
::v-deep .el-submenu .el-submenu__title,
::v-deep .el-menu-item.is-active,
.el-menu-item {
    height: 45px;
    line-height: 45px;
    font-size: 15px;
    display: flex;
    align-items: center;
}

.zoomed {
    display: none;
}

/* Updated styles for active, hover and focus states */
::v-deep .el-submenu.is-active .el-submenu__title,
::v-deep .el-menu .el-menu-item.is-active {
    border-bottom: 0px;
    background-color: #d0ecff;
    color: var(--blue-200);
}

::v-deep .el-menu-item:hover,
::v-deep .el-menu-item:focus,
::v-deep .el-submenu__title:hover,
::v-deep .el-submenu__title:focus {
    background-color: #f0f8ff;
    color: var(--blue-200) !important;
}

/* Update navbar text color to #212529 */
::v-deep .el-submenu .el-submenu__title,
::v-deep .el-menu-item {
    color: #212529 !important; /* Updated navbar text color */
}

::v-deep .el-submenu.is-active .el-submenu__title i {
    color: var(--blue-200);
}

.el-menu--horizontal .el-menu .el-menu-item.is-active {
    background: var(--blue-200) !important;
    color: var(--white-common) !important;
}

/* Style icon mũi tên trái/phải khi menu item active */
.el-menu--horizontal .el-menu .el-submenu.is-active > .el-submenu__title .el-submenu__icon-arrow,
.el-menu--horizontal .el-menu .el-submenu.is-active > .el-submenu__title .el-icon-arrow-right,
.el-menu--horizontal .el-menu .el-submenu.is-active > .el-submenu__title .el-icon-arrow-left,
.el-menu--horizontal .el-menu .el-menu-item.is-active .el-submenu__icon-arrow,
.el-menu--horizontal .el-menu .el-menu-item.is-active .el-icon-arrow-right,
.el-menu--horizontal .el-menu .el-menu-item.is-active .el-icon-arrow-left,
.el-menu--horizontal .el-menu .el-submenu.is-active > .el-submenu__title i[class*="el-icon-arrow"],
.el-menu--horizontal .el-menu .el-menu-item.is-active i[class*="el-icon-arrow"] {
    color: var(--white-common) !important;
}

/* Update dropdown menu item hover color to match header background */
.el-menu--horizontal .el-menu .el-menu-item:hover {
    background: #f0f8ff;
    color: var(--blue-200);
}

/* Remove the white text color on hover that was defined here previously */
/* .el-menu--horizontal .el-menu .el-menu-item:hover {
    background: #186ab2;
    color: #ffffff;
} */

::v-deep .el-menu--popup {
    margin-top: -5px !important;
}

.mobile-nav-container {
    padding: 10px;
}

.mobile-menu-toggle {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

::v-deep .el-menu-vertical-demo {
    width: 100%;
}

/* Additional responsive styles */
@media (max-width: 767px) {
    .el-menu-horizontal-demo {
        display: none;
    }
}

@media (min-width: 768px) {
    .mobile-nav-container {
        display: none;
    }
}
</style>
